import React from 'react';

const FileInput = ({ onFileSelect }) => {

    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (file) {
          onFileSelect(file);
        }
      };

    return (
        <div>
            <input type="file" onChange={handleFileSelect} />
        </div>
    );
};

export default FileInput;